"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styles = require("@material-ui/core/styles");
var _TimelineConnector = _interopRequireDefault(require("@material-ui/lab/TimelineConnector"));
var _TimelineDot = _interopRequireDefault(require("@material-ui/lab/TimelineDot"));
var _TimelineContent = _interopRequireDefault(require("@material-ui/lab/TimelineContent"));
var _TimelineItem = _interopRequireDefault(require("@material-ui/lab/TimelineItem"));
var _TimelineOppositeContent = _interopRequireDefault(require("@material-ui/lab/TimelineOppositeContent"));
var _TimelineSeparator = _interopRequireDefault(require("@material-ui/lab/TimelineSeparator"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Typography = _interopRequireDefault(require("../../Typography"));
var _constants = require("../constants");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    captionText: {
      color: theme.palette.secondary[400]
    },
    contentConnector: {
      backgroundColor: '#95A8B1',
      // Unable to find in Fuse Theme
      marginBottom: '-8px',
      marginTop: '-8px',
      minHeight: theme.spacing(10)
    },
    dateText: {
      fontWeight: 'bold'
    },
    timelineDot: {
      backgroundColor: '#556E7A' // Unable to find in Fuse Theme
    },

    timelineDotHidden: {
      display: 'none'
    }
  };
});
var TimelineItem = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _props$activity = props.activity,
    activity = _props$activity === void 0 ? {} : _props$activity,
    renderConnector = props.renderConnector,
    _props$TimelineConnec = props.TimelineConnectorProps,
    TimelineConnectorProps = _props$TimelineConnec === void 0 ? {} : _props$TimelineConnec,
    _props$TimelineConten = props.TimelineContentProps,
    TimelineContentProps = _props$TimelineConten === void 0 ? {} : _props$TimelineConten,
    _props$TimelineDotPro = props.TimelineDotProps,
    TimelineDotProps = _props$TimelineDotPro === void 0 ? {} : _props$TimelineDotPro,
    _props$TimelineItemPr = props.TimelineItemProps,
    TimelineItemProps = _props$TimelineItemPr === void 0 ? {} : _props$TimelineItemPr,
    _props$TimelineOpposi = props.TimelineOppositeContentProps,
    TimelineOppositeContentProps = _props$TimelineOpposi === void 0 ? {} : _props$TimelineOpposi,
    _props$TimelineSepara = props.TimelineSeparatorProps,
    TimelineSeparatorProps = _props$TimelineSepara === void 0 ? {} : _props$TimelineSepara;
  var _activity$connectorPr = activity.connectorProps,
    connectorProps = _activity$connectorPr === void 0 ? {} : _activity$connectorPr,
    _activity$contentProp = activity.contentProps,
    contentProps = _activity$contentProp === void 0 ? {} : _activity$contentProp,
    date = activity.date,
    description = activity.description,
    _activity$dotProps = activity.dotProps,
    dotProps = _activity$dotProps === void 0 ? {} : _activity$dotProps,
    icon = activity.icon,
    id = activity.id,
    _activity$itemProps = activity.itemProps,
    itemProps = _activity$itemProps === void 0 ? {} : _activity$itemProps,
    _activity$oppositeCon = activity.oppositeContentProps,
    oppositeContentProps = _activity$oppositeCon === void 0 ? {} : _activity$oppositeCon,
    _activity$separatorPr = activity.separatorProps,
    separatorProps = _activity$separatorPr === void 0 ? {} : _activity$separatorPr,
    subtitle = activity.subtitle,
    time = activity.time;
  var styles = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_TimelineItem["default"], (0, _extends2["default"])({
    ref: ref,
    key: id
  }, TimelineItemProps, itemProps), /*#__PURE__*/_react["default"].createElement(_TimelineOppositeContent["default"], (0, _extends2["default"])({}, TimelineOppositeContentProps, oppositeContentProps), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, date && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: styles.dateText,
    variant: "body1"
  }, date), time && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "caption",
    className: styles.captionText
  }, time))), /*#__PURE__*/_react["default"].createElement(_TimelineSeparator["default"], (0, _extends2["default"])({}, TimelineSeparatorProps, separatorProps), /*#__PURE__*/_react["default"].createElement(_TimelineDot["default"], (0, _extends2["default"])({
    className: (0, _classnames["default"])(styles.timelineDot, (0, _defineProperty2["default"])({}, styles.timelineDotHidden, TimelineDotProps.hidden || dotProps.hidden))
  }, TimelineDotProps, dotProps), icon), renderConnector && /*#__PURE__*/_react["default"].createElement(_TimelineConnector["default"], (0, _extends2["default"])({
    className: styles.contentConnector
  }, TimelineConnectorProps, connectorProps))), /*#__PURE__*/_react["default"].createElement(_TimelineContent["default"], (0, _extends2["default"])({}, TimelineContentProps, contentProps), description, subtitle));
});
TimelineItem.displayName = 'TimelineItem';
TimelineItem.propTypes = process.env.NODE_ENV !== "production" ? {
  activity: _constants.TimelineActivityPropType,
  renderConnector: _propTypes["default"].bool,
  TimelineConnectorProps: _constants.TimelineConnectorPropType,
  TimelineContentProps: _constants.TimelineContentPropType,
  TimelineDotProps: _constants.TimelineDotPropType,
  TimelineItemProps: _constants.TimelineItemPropType,
  TimelineOppositeContentProps: _constants.TimelineOppositeContentPropType,
  TimelineSeparatorProps: _constants.TimelineSeparatorPropType
} : {};
var _default = TimelineItem;
exports["default"] = _default;